import { useState } from "react";
import { Icon } from "dash-ui";
import { SUBSCRIPTION_COLORS } from "../../SubscriptionComponents.constants";
import ProductFeatures from "../ProductFeatures/ProductFeatures";

interface ICardFeaturesProps {
  featuresList: string[];
  featuresSectionTitle: string;
  keyFeaturesLabel: string;
  isMobile: boolean;
}

export default function CardFeatures({
  featuresList,
  featuresSectionTitle,
  keyFeaturesLabel,
  isMobile,
}: ICardFeaturesProps) {
  const [isFeaturesOpen, setIsFeaturesOpen] = useState(false);

  return (
    <div
      className={`bg-white px-5 flex-grow ${!isMobile ? "pt-8 pb-9" : ""}`}
      style={
        isMobile
          ? {
              paddingTop: isFeaturesOpen ? "16px" : "0",
              paddingBottom: "0",
              transition: "padding 500ms ease-in-out",
            }
          : {}
      }
    >
      {isMobile ? (
        <>
          {/* Mobile: Show title and features when open */}
          <div
            className="overflow-hidden transition-all duration-500 ease-in-out"
            style={{
              maxHeight: isFeaturesOpen ? "1000px" : "0",
            }}
          >
            <div
              className="transition-all duration-500 ease-in-out"
              style={{
                transform: isFeaturesOpen
                  ? "translateY(0)"
                  : "translateY(-16px)",
                opacity: isFeaturesOpen ? 1 : 0,
              }}
            >
              <div className="pt-2 pb-6">
                <h4
                  className="text-base font-semibold text-center mb-7"
                  style={{ color: SUBSCRIPTION_COLORS.secondaryText }}
                >
                  {featuresSectionTitle}
                </h4>
                <ProductFeatures featuresList={featuresList} />
              </div>
            </div>
          </div>

          {/* Mobile Accordion Toggle - at bottom when open */}
          <button
            onClick={() => setIsFeaturesOpen(!isFeaturesOpen)}
            className="w-full flex items-center justify-between py-4 transition-all"
          >
            <span
              className="text-base font-semibold"
              style={{ color: SUBSCRIPTION_COLORS.secondaryText }}
            >
              {keyFeaturesLabel}
            </span>
            <Icon
              name="arrowDown"
              size={24}
              color={SUBSCRIPTION_COLORS.secondaryText}
              className={`transition-transform duration-500 ease-in-out ${
                isFeaturesOpen ? "rotate-180" : ""
              }`}
            />
          </button>
        </>
      ) : (
        <>
          {/* Desktop View */}
          <h4
            className="text-base font-semibold text-center mb-7"
            style={{ color: SUBSCRIPTION_COLORS.secondaryText }}
          >
            {featuresSectionTitle}
          </h4>
          <ProductFeatures featuresList={featuresList} />
        </>
      )}
    </div>
  );
}
